import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {SnackbarProvider} from "notistack";
import {Box, CircularProgress} from "@mui/material";

import ListingEmptyState from "components/Product/Table/ListingEmptyState";
import {FilterProvider} from "contexts/filterContext";
import {ProductDataProvider} from "contexts/productDataContext";
import {canAccessEnrichment} from "utils/enrichmentAccess";

import EnrichmentScreen from "./components/EnrichmentScreen";
import {ENRICHMENT_DEFAULT_FILTERS} from "./enrichmentConstants";

EnrichmentPage.propTypes = {
    match: PropTypes.object.isRequired,
    authorizations: PropTypes.array,
    organization: PropTypes.object,
    member: PropTypes.object,
};

function EnrichmentPage({match, authorizations, organization, member}) {
    if (!organization) {
        return (
            <Box sx={{display: 'flex', justifyContent: 'center', padding: '48px'}}>
                <CircularProgress/>
            </Box>
        );
    }

    if (!canAccessEnrichment(authorizations, organization)) {
        return <ListingEmptyState titleId="enrichment.disabled.title" descriptionId="enrichment.disabled.description"/>;
    }

    const retailerId = match.params.id ?? null;
    const currentUserName = [member?.givenName, member?.familyName].filter(Boolean).join(' ') || null;

    return (
        <SnackbarProvider>
            {null === retailerId ? (
                <ProductDataProvider>
                    <FilterProvider initialFilters={ENRICHMENT_DEFAULT_FILTERS}>
                        <EnrichmentScreen retailerId={null} currentUserName={currentUserName}/>
                    </FilterProvider>
                </ProductDataProvider>
            ) : (
                <EnrichmentScreen retailerId={retailerId} currentUserName={currentUserName}/>
            )}
        </SnackbarProvider>
    );
}

const mapStateToProps = (state) => ({
    authorizations: state.authentication.authorizations,
    organization: state.currentOrganization.retrieved,
    member: state.authentication.member,
});

export default connect(mapStateToProps)(EnrichmentPage);
